import { Flex } from "grid-styled";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Transition } from "react-transition-group";
import styled, { ThemeProvider } from "styled-components";
import infraMonitorService from "../../api/infraMonitorService";
import {
  Header,
  Loader,
  ProjectBudgetExpChart,
  ProjectLineChart,
  ProjectProgressChart,
  EvaluationScoreChart,
} from "../../components/layouts";
import { HomePage } from "../../components/layouts/page";
import ProjectProcurementChart from "../../components/layouts/projectProcurementChart/projectProcurementChart";
import WardChart from "../../components/layouts/WardChart/WardChart";
import { Heading, media, Text } from "../../components/styled";
import {
  BasicMap,
  DashboardProjects,
  Legend,
  Map,
} from "../../components/visualization";
import Treemap from "../../components/visualization/treemap-chart/treemap";
import { images } from "../../config/index";
import { setFilters } from "../../infraMonitor/actions";

import {
  getProjectsStats,
  getProjectsStatsSuccess,
  setSelectedWard,
} from "../../infraMonitor/projects-stats/actions";
import {
  dashboardLocalization,
  formattedCurrency,
  helpTextLocalization,
  number,
  projectsLocalization,
  currency,
  commonLocalization,
} from "../../localization";
import { getMunData } from "../../utils";
import theme from "../../utils/theme";

const mapInfo = getMunData();

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "all",
      selectedDropDown: "count",
      isOpen: false,
      selectedYear: props.fiscalYear,
      selectedProjectType: "infrastructure",
      isWardDropDownOpen: false,
      selectedWard: "all",
      categoryData: [],
      wardData: [],
      localProjectData: null,
      hoveredWardStats: null,
      localProjectFetching: false,
    };

    this.municipality = props.municipality;
    this.handleOnTabClick = this.handleOnTabClick.bind(this);
    this.selectedYearData = {};
  }

  handleOnTabClick(tab) {
    this.setState({
      selectedTab: tab,
    });
  }

  componentDidMount() {
    const { fiscalYear, dispatchProjectsStats } = this.props;

    dispatchProjectsStats(
      {
        "fiscal-year": fiscalYear,
        "project-type": "infrastructure",
      },
      this.municipality
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.selectedYear !== nextProps.fiscalYear) {
      this.setState(
        {
          selectedYear: nextProps.fiscalYear,
        },
        () => {
          if (this.state.selectedProjectType === "local-project") {
            this.setState({ localProjectFetching: true });
            infraMonitorService
              .getLocalProjectData(
                this.municipality.title_en,
                nextProps.fiscalYear
              )
              .then((localProjectData) => {
                this.setState({
                  localProjectData,
                  localProjectFetching: false,
                });
              })
              .catch((err) => {
                console.error(
                  "Failed to fetch local project data on fiscal year change:",
                  err
                );
              });
          } else {
            this.props.dispatchProjectsStats(
              {
                "fiscal-year": nextProps.fiscalYear,
                "project-type": this.state.selectedProjectType,
              },
              this.municipality
            );
          }
        }
      );
    }
  }

  getMapData = (data) => {
    const { ward_wise } = data;
    if (!Object.keys(data).length) return null;

    if (this.state.selectedDropDown === "budget") {
      return Object.keys(ward_wise).map((key) => ({
        ward: key,
        value: ward_wise[key].total.budget.value,
      }));
    }

    return Object.keys(ward_wise).map((key) => ({
      ward: key,
      value: ward_wise[key].total.count,
    }));
  };

  getProjectsData = (data, type) => {
    if (!data) {
      return null;
    }
    const { overall, ward_wise } = data;
    const { selectedWard } = this.props;
    const initial = {
      total_projects: 0,
      worth_of_projects: 0,
      completion: 0,
      implementation: 0,
      pipeline: 0,
    };

    const data2 = selectedWard === "all" ? overall : ward_wise[selectedWard];
    if (type === "budget") {
      initial.worth_of_projects =
        data2 && Object.keys(data2).length
          ? formattedCurrency(data2.total.budget.value)
          : 0;
      delete initial.total_projects;
    } else {
      initial.total_projects =
        data2 && Object.keys(data2).length ? data2.total.count : 0;
      delete initial.worth_of_projects;
    }

    if (!data2 || !Object.keys(data2).length) return initial;

    Object.keys(data2.status).forEach((key) => {
      if (type === "budget") {
        initial[key] = formattedCurrency(data2.status[key].budget.value);
      } else {
        initial[key] = data2.status[key].count;
      }
    });

    return initial;
  };

  getBarData = (data) => {
    const { overall, ward_wise } = data;

    if (!Object.keys(overall).length) return [];

    if (this.state.selectedDropDown === "budget") {
      return Object.keys(ward_wise).map((key) => ({
        ward: key,
        value: ward_wise[key].total.budget.value,
        formatted: ward_wise[key].total.budget.formatted,
      }));
    }

    return Object.keys(ward_wise).map((key) => ({
      ward: key,
      value: ward_wise[key].total.count,
    }));
  };

  getLegendData(data, totalWards) {
    if (!data.overall.total) return ["", "", "", ""];

    if (this.state.selectedDropDown === "budget") {
      const budgetWardWise = Object.keys(data.ward_wise)
        .filter((d) => d <= totalWards)
        .map((key) => data.ward_wise[key].total.budget.value);
      const highest =
        budgetWardWise.length > 0 ? Math.max(...budgetWardWise) : 0;

      const value = Math.floor(highest / 4);
      if (value === 0) return ["", "", "", ""];
      const x = formattedCurrency(value);
      const x2 = formattedCurrency(value * 2);
      const x3 = formattedCurrency(value * 3);

      if (this.props.selectedLanguage === "np") {
        return [
          `<${x}`,
          `${x.split(" ")[0]}-${x2}`,
          `${x2.split(" ")[0]}-${x3}`,
          `>${x3}`,
        ];
      }
      return [`<${x}`, `${x}-${x2}`, `${x2}-${x3}`, `>${x3}`];
    }

    const countWardWise = Object.keys(data.ward_wise)
      .filter((d) => d <= totalWards)
      .map((key) => data.ward_wise[key].total.count);
    const highest = countWardWise.length > 0 ? Math.max(...countWardWise) : 0;

    if (highest === 0) return ["", "", "", ""];
    else if (highest === 1) return ["<0", "0", "1", ">1"];

    const x = number(Math.floor(highest * 0.25));
    const x2 = number(Math.floor(highest * 0.5));
    const x3 = number(Math.floor(highest * 0.75));

    return [`<${x}`, `${x}-${x2}`, `${x2}-${x3}`, `>${x3}`];
  }

  handleDropdownMenu = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleProjects = (value) => {
    this.setState({
      ...this.state,
      selectedDropDown: value,
      isOpen: false,
    });
  };

  onClickOutsideListener = () => {
    document.removeEventListener("click", this.onClickOutsideListener);
    this.setState({
      ...this.state,
      isOpen: false,
    });
  };

  getTotalWards = () => {
    const { municipality, municipalities } = this.props;
    const currentMunicipality = municipalities.find(
      (val) => val.name === municipality.title_en
    );
    return currentMunicipality.no_of_wards;
  };

  onTabChange = async (projectType) => {
    if (this.state.selectedProjectType !== projectType) {
      this.setState({ ...this.state, selectedProjectType: projectType });

      const { fiscalYear, dispatchProjectsStats } = this.props;
      const municipality = this.municipality.title_en;

      if (projectType === "local-project") {
        this.setState({ localProjectFetching: true });
        try {
          const localProjectData =
            await infraMonitorService.getLocalProjectData(
              municipality,
              fiscalYear
            );

          this.setState({ localProjectData, localProjectFetching: false });
        } catch (err) {
          console.error("Failed to fetch local project data:", err);
        }
      } else {
        infraMonitorService.getSocialData("dhangadhi", this.state.fiscalYear);
        dispatchProjectsStats(
          {
            "fiscal-year": fiscalYear,
            "project-type": projectType,
          },
          this.municipality
        );
      }
    }
  };

  render() {
    const { localProjectData, selectedYear } = this.state;

    let projectsByWard = [];
    let projectStats = "";
    let wardWiseEvaluatedScore = [];
    let evaluatedTotalScore = "";

    if (
      localProjectData &&
      localProjectData.data &&
      typeof localProjectData.data === "object"
    ) {
      const municipalityKeys = Object.keys(localProjectData.data);
      if (municipalityKeys.length > 0) {
        const municipalityKey = municipalityKeys[0];
        const selectedYearData =
          localProjectData.data[municipalityKey][selectedYear];

        this.selectedYearData = selectedYearData;

        if (selectedYearData) {
          projectsByWard = selectedYearData.projects_count_by_ward || [];
          projectStats = selectedYearData.counts || "";
          wardWiseEvaluatedScore =
            selectedYearData.evaluated_projects_count_by_score || [];
          evaluatedTotalScore =
            selectedYearData.evaluated_projects_count_by_score_total || "";
        }
      }
    }

    const {
      data: { data: projectsStats },
      fetching,
    } = this.props.projectsStats;

    const {
      title: {
        label: projectDistributionTitle,
        projects: projectDistributionProjects,
        budget: projectDistributionBudget,
        infrastructure: infrastructure,
        social: social,
      },
    } = dashboardLocalization[this.props.selectedLanguage];
    const { map: mapHelpText } =
      helpTextLocalization[this.props.selectedLanguage];

    const totalWards = Array.from({ length: this.getTotalWards() }, (x, i) => ({
      value: i + 1,
      text: number(i + 1),
    })); // get wards

    const mapData = this.getMapData(projectsStats);

    const allProjectsData = this.getProjectsData(
      projectsStats,
      this.state.selectedDropDown
    );
    const ucProjectsData = projectsStats.project_type_wise
      ? this.getProjectsData(
          projectsStats.project_type_wise.user_community,
          this.state.selectedDropDown
        )
      : null;
    const tenderedProjectsData = projectsStats.project_type_wise
      ? this.getProjectsData(
          projectsStats.project_type_wise.contractor,
          this.state.selectedDropDown
        )
      : null;
    const quotationWorkData = null;

    const legendData =
      this.state.selectedProjectType === "local-project"
        ? this.getLegendData(
            {
              overall: {
                total: {
                  count: projectsByWard.reduce(
                    (acc, ward) => acc + (ward.value || 0),
                    0
                  ),
                },
              },
              ward_wise: projectsByWard.reduce((acc, ward) => {
                acc[ward.ward] = {
                  total: {
                    count: ward.value || 0,
                    budget: { value: ward.value || 0 },
                  },
                };
                return acc;
              }, {}),
            },
            totalWards.length
          )
        : this.getLegendData(projectsStats, totalWards);

    const { selectedLanguage } = this.props;
    const { projectTable: projectLang } =
      projectsLocalization[selectedLanguage];
    const {
      stats,
      statsFor,
      allWards,
      ward,
      expectedBudget,
      submitted,
      evaluated,
      budget,
      budgetFor,
      total_projects,
    } = commonLocalization[selectedLanguage];

    const { isOpen } = this.state;
    const activeClass = isOpen ? "active-dropdown" : "";
    const textSizeClass = `uppercase ${
      selectedLanguage === "en" ? "text-xs" : "text-sm"
    }`;

    return (
      <ThemeProvider theme={theme}>
        <div className='homepage wrapper'>
          <div>
            {fetching && <Loader />}
            <Header />
            <div className='project-tabs'>
              <Flex className='flex gap-12'>
                <div
                  onClick={() => this.onTabChange("infrastructure")}
                  className={
                    this.state.selectedProjectType === "infrastructure"
                      ? "project-tabs-item active"
                      : "project-tabs-item"
                  }
                >
                  {this.props.selectedLanguage === "en"
                    ? "Infrastructure"
                    : "पूर्वाधार"}
                </div>
                <div
                  onClick={() => this.onTabChange("social")}
                  className={
                    this.state.selectedProjectType === "social"
                      ? "project-tabs-item active"
                      : "project-tabs-item"
                  }
                >
                  {this.props.selectedLanguage === "en" ? "Social" : "सामाजिक"}
                </div>
                {/* no optional chaining support in this babel config, so
                    manual null-guard replaces
                    this.props.projectsStats?.data?.metadata?.features?.["local-project"] */}
                {this.props.projectsStats &&
                  this.props.projectsStats.data &&
                  this.props.projectsStats.data.metadata &&
                  this.props.projectsStats.data.metadata.features &&
                  this.props.projectsStats.data.metadata.features[
                    "local-project"
                  ] &&
                  <div
                    onClick={() => this.onTabChange("local-project")}
                    className={
                      this.state.selectedProjectType === "local-project"
                        ? "project-tabs-item active"
                        : "project-tabs-item"
                    }
                  >
                    {this.props.selectedLanguage === "en"
                      ? "Local Project"
                      : "स्थानीय परियोजना"}
                  </div>
                }
              </Flex>
            </div>
            <div className={"filter-btn-header"}>
              <Heading.h2 uppercase className='project-distribution'>
                {this.props.selectedLanguage === "en"
                  ? projectDistributionTitle
                  : null}
                <div className='btn-wrapper inline-flex items-center gap-4'>
                  <div className={`selection-wrap ${activeClass}`}>
                    <Dropdown>
                      <DropdownButton
                        onMouseLeave={() => {
                          document.addEventListener(
                            "click",
                            this.onClickOutsideListener
                          );
                        }}
                        isOpen={this.state.isOpen}
                        onClick={this.handleDropdownMenu}
                      >
                        <Title
                          className='title'
                          isOpen={this.state.isOpen}
                          lang={selectedLanguage}
                        >
                          {this.state.selectedDropDown === "count"
                            ? projectDistributionProjects
                            : projectDistributionBudget}
                        </Title>
                        <DropdownIcon isOpen={this.state.isOpen} />
                      </DropdownButton>

                      <Transition
                        in={this.state.isOpen}
                        timeout={100}
                        mountOnEnter
                      >
                        {(state) => (
                          <DropdownMenu
                            style={{
                              ...transitionStyles[state],
                            }}
                          >
                            <ul className='dropdown-list'>
                              <li onClick={() => this.handleProjects("count")}>
                                {projectDistributionProjects}
                              </li>
                              <li onClick={() => this.handleProjects("budget")}>
                                {projectDistributionBudget}
                              </li>
                            </ul>
                          </DropdownMenu>
                        )}
                      </Transition>
                    </Dropdown>
                  </div>
                </div>
                {this.props.selectedLanguage === "np"
                  ? ` ${projectDistributionTitle}`
                  : null}
                {this.state.selectedDropDown !== "count" && (
                  <Text.span style={{ textTransform: "none", marginLeft: 9 }}>
                    {this.props.selectedLanguage === "en"
                      ? "(in NRs.)"
                      : "(नेरु)"}
                  </Text.span>
                )}
              </Heading.h2>
            </div>
            <HomePage lang={selectedLanguage}>
              {this.state.selectedProjectType === "infrastructure" && (
                <LeftSection className='left-section' lang={selectedLanguage}>
                  <div className='dashboard-layout'>
                    <div className='grid-layout'>
                      <div>
                        <Heading.h3 className='flex items-center'>
                          <Text.span className='help-text'>
                            <Text.span>
                              <img
                                className='help-icon'
                                height={18}
                                width={18}
                                src={images.icons.help}
                                alt='help'
                              />
                            </Text.span>
                            <Text.span className='help-text__content tooltip'>
                              <Text.span className='tooltip-arrow'>
                                arrow
                              </Text.span>
                              {this.state.selectedDropDown === "count"
                                ? mapHelpText.projects
                                : mapHelpText.budget}
                            </Text.span>
                          </Text.span>
                          <Text.span className='map-help-title'>{`(${mapHelpText.title})`}</Text.span>
                        </Heading.h3>
                        <div className='upper-chart-section w-full'>
                          <div className='map-section w-full'>
                            {mapInfo.basicMap === true ? (
                              <BasicMap
                                data={mapData}
                                municipality={this.municipality}
                              />
                            ) : (
                              mapData && (
                                <Map
                                  class={"w-full"}
                                  data={mapData}
                                  selectedDropDown={this.state.selectedDropDown}
                                  municipality={this.municipality}
                                />
                              )
                            )}
                            {mapInfo.basicMap === true ? (
                              ""
                            ) : (
                              <Legend legendData={legendData} />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className='dashboard-layout inner-layout'>
                        <div className='project-section'>
                          <div className='project-type-section flex'>
                            {this.state.selectedTab === "all" && (
                              <Fragment>
                                {allProjectsData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={allProjectsData}
                                    type='all'
                                    selectedWard={this.props.selectedWard}
                                    projectType='infrastructure'
                                  />
                                )}
                              </Fragment>
                            )}

                            {this.state.selectedTab === "user_committee" && (
                              <Fragment>
                                {ucProjectsData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={ucProjectsData}
                                    type='user-committee'
                                    selectedWard={this.props.selectedWard}
                                    projectType='infrastructure'
                                  />
                                )}
                              </Fragment>
                            )}

                            {this.state.selectedTab === "tender" && (
                              <Fragment>
                                {tenderedProjectsData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={tenderedProjectsData}
                                    type='tender'
                                    selectedWard={this.props.selectedWard}
                                    projectType='infrastructure'
                                  />
                                )}
                              </Fragment>
                            )}

                            {this.state.selectedTab === "quotation" && (
                              <Fragment>
                                {quotationWorkData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={quotationWorkData}
                                    type='quotation'
                                    selectedWard={this.props.selectedWard}
                                    projectType='infrastructure'
                                  />
                                )}
                              </Fragment>
                            )}

                            {(ucProjectsData ||
                              quotationWorkData ||
                              tenderedProjectsData) && (
                              <ul>
                                {ucProjectsData && (
                                  <li
                                    onClick={() =>
                                      this.handleOnTabClick("user_committee")
                                    }
                                    className={
                                      this.state.selectedTab ===
                                      "user_committee"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span>{projectLang.userCommittee}</span>
                                  </li>
                                )}
                                {quotationWorkData && (
                                  <li
                                    onClick={() =>
                                      this.handleOnTabClick("quotation")
                                    }
                                    className={
                                      this.state.selectedTab === "quotation"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span>{projectLang.quotationWork}</span>
                                  </li>
                                )}
                                {tenderedProjectsData && (
                                  <li
                                    onClick={() =>
                                      this.handleOnTabClick("tender")
                                    }
                                    className={
                                      this.state.selectedTab === "tender"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span>{projectLang.contractor}</span>
                                  </li>
                                )}
                              </ul>
                            )}
                          </div>
                          <ProjectBudgetExpChart />
                        </div>
                        <ProjectLineChart />
                      </div>
                    </div>
                    <div className='dashboard-layout'>
                      <WardChart
                        chartTitle={
                          selectedLanguage === "np"
                            ? "वडागतरुपमा परियोजनाको वितरण"
                            : "Ward wise bar view"
                        }
                        chartHelpText={
                          selectedLanguage === "np"
                            ? " यस bar chart ले विभिन्‍न वडा मार्फत वितरण परियोजनाहरुको कुल संख्या देखाउँछ।"
                            : "This bar chart shows the distribution of total  number of infrastructure projects across the different wards."
                        }
                        projectType={"infrastructure"}
                        data={this.props}
                        selectedWard={this.props.selectedWard}
                        selectedDropDown={this.state.selectedDropDown}
                      />
                      <Treemap
                        chartTitle={
                          selectedLanguage === "np"
                            ? "पुर्वाधार परियोजनाका प्रकारको TREEMAP CHART दृश्य"
                            : "Treemap chart view of infrastructure categories "
                        }
                        chartHelpText={
                          selectedLanguage === "np"
                            ? " यस tree chart मा परियोजनाहरुको कुल सख्या वितरण विभिन्‍न पुर्वाधार परियोजनाका प्रकार अनुसार गरिएको छ।"
                            : "This tree chart shows the total number of infrastructure projects distributed across the different infrastructure project categories."
                        }
                        projectType={"infrastructure"}
                        data={this.props}
                        selectedWard={this.props.selectedWard}
                        selectedLanguage={selectedLanguage}
                      />
                    </div>
                    <div className='grid-chart-layout'>
                      <ProjectProcurementChart
                        selectedDropDown={this.state.selectedDropDown}
                      />
                      <ProjectProgressChart />
                    </div>
                  </div>
                </LeftSection>
              )}
              {this.state.selectedProjectType === "social" && (
                <LeftSection
                  className='left-section social'
                  lang={selectedLanguage}
                >
                  <div className='dashboard-layout'>
                    <div className='grid-layout'>
                      <div>
                        <Heading.h3 className='flex items-center'>
                          <Text.span className='help-text'>
                            <Text.span className='help-text__icon'>
                              <img
                                className='help-icon'
                                height={18}
                                width={18}
                                src={images.icons.help}
                                alt='help'
                              />
                            </Text.span>
                            <Text.span className='help-text__content tooltip'>
                              <Text.span className='tooltip-arrow'>
                                arrow
                              </Text.span>
                              {this.state.selectedDropDown === "count"
                                ? mapHelpText.projects
                                : mapHelpText.budget}
                            </Text.span>
                          </Text.span>
                          <Text.span>{`(${mapHelpText.title})`}</Text.span>
                        </Heading.h3>
                        <div className='upper-chart-section w-full'>
                          <div className='map-section w-full'>
                            {mapInfo.basicMap === true ? (
                              <BasicMap
                                data={mapData}
                                municipality={this.municipality}
                              />
                            ) : (
                              mapData && (
                                <Map
                                  projectType={"social"}
                                  class={"w-full"}
                                  data={mapData}
                                  selectedDropDown={this.state.selectedDropDown}
                                  municipality={this.municipality}
                                />
                              )
                            )}
                            {mapInfo.basicMap === true ? (
                              ""
                            ) : (
                              <Legend legendData={legendData} />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className='dashboard-layout'>
                        <div className='project-section'>
                          <div className='project-type-section flex'>
                            {this.state.selectedTab === "all" && (
                              <Fragment>
                                {allProjectsData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={allProjectsData}
                                    type='all'
                                    selectedWard={this.props.selectedWard}
                                    projectType='social'
                                  />
                                )}
                              </Fragment>
                            )}

                            {this.state.selectedTab === "user_committee" && (
                              <Fragment>
                                {ucProjectsData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={ucProjectsData}
                                    type='user-committee'
                                    selectedWard={this.props.selectedWard}
                                    projectType='social'
                                  />
                                )}
                              </Fragment>
                            )}

                            {this.state.selectedTab === "tender" && (
                              <Fragment>
                                {tenderedProjectsData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={tenderedProjectsData}
                                    type='tender'
                                    selectedWard={this.props.selectedWard}
                                    projectType='social'
                                  />
                                )}
                              </Fragment>
                            )}

                            {this.state.selectedTab === "quotation" && (
                              <Fragment>
                                {quotationWorkData && (
                                  <DashboardProjects
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    data={quotationWorkData}
                                    type='quotation'
                                    selectedWard={this.props.selectedWard}
                                    projectType='social'
                                  />
                                )}
                              </Fragment>
                            )}

                            {(ucProjectsData ||
                              quotationWorkData ||
                              tenderedProjectsData) && (
                              <ul>
                                {ucProjectsData && (
                                  <li
                                    onClick={() =>
                                      this.handleOnTabClick("user_committee")
                                    }
                                    className={
                                      this.state.selectedTab ===
                                      "user_committee"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span>{projectLang.userCommittee}</span>
                                  </li>
                                )}
                                {quotationWorkData && (
                                  <li
                                    onClick={() =>
                                      this.handleOnTabClick("quotation")
                                    }
                                    className={
                                      this.state.selectedTab === "quotation"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span>{projectLang.quotationWork}</span>
                                  </li>
                                )}
                                {tenderedProjectsData && (
                                  <li
                                    onClick={() =>
                                      this.handleOnTabClick("tender")
                                    }
                                    className={
                                      this.state.selectedTab === "tender"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span>{projectLang.contractor}</span>
                                  </li>
                                )}
                              </ul>
                            )}
                          </div>
                          <ProjectBudgetExpChart />
                        </div>
                        <ProjectLineChart projectType={"social"} />
                      </div>
                    </div>
                    <div className='dashboard-layout'>
                      <WardChart
                        chartTitle={
                          selectedLanguage === "np"
                            ? "वडागतरुपमा परियोजनाको वितरण"
                            : "Ward wise bar view"
                        }
                        chartHelpText={
                          selectedLanguage === "np"
                            ? " यस bar chart ले विभिन्‍न वडा मार्फत वितरण परियोजनाहरुको कुल संख्या देखाउँछ।"
                            : "This bar chart shows the distribution of total  number of social projects across the different wards."
                        }
                        projectType={"social"}
                        data={this.props}
                        selectedWard={this.props.selectedWard}
                        selectedDropDown={this.state.selectedDropDown}
                      />
                      <Treemap
                        chartTitle={
                          selectedLanguage === "np"
                            ? "सामाजिक परियोजनाका प्रकारको TREEMAP CHART दृश्य"
                            : "Tree chart view of social types"
                        }
                        chartHelpText={
                          selectedLanguage === "np"
                            ? "यस tree chart मा परियोजनाहरुको कुल सख्या वितरण विभिन्‍न सामाजिक परियोजनाका प्रकार अनुसार गरिएको छ।"
                            : "This tree chart shows the total number of social projects distributed across the different social project categories."
                        }
                        projectType={"social"}
                        data={this.props}
                        selectedWard={this.props.selectedWard}
                        selectedLanguage={selectedLanguage}
                      />
                    </div>
                  </div>
                </LeftSection>
              )}
              {this.state.selectedProjectType === "local-project" &&
                (this.state.localProjectFetching ? (
                  <Loader />
                ) : (
                  <LeftSection className='left-section' lang={selectedLanguage}>
                    <div className='dashboard-layout'>
                      <div className='grid-layout'>
                        <div>
                          <Heading.h3 className='flex items-center'>
                            <Text.span className='help-text'>
                              <Text.span>
                                <img
                                  className='help-icon'
                                  height={18}
                                  width={18}
                                  src={images.icons.help}
                                  alt='help'
                                />
                              </Text.span>
                              <Text.span className='help-text__content tooltip'>
                                <Text.span className='tooltip-arrow'>
                                  arrow
                                </Text.span>
                                {this.state.selectedDropDown === "count"
                                  ? mapHelpText.projects
                                  : mapHelpText.budget}
                              </Text.span>
                            </Text.span>
                            <Text.span className='map-help-title'>{`(${mapHelpText.title})`}</Text.span>
                          </Heading.h3>
                          <div className='upper-chart-section w-full'>
                            <div className='map-section w-full'>
                              {mapInfo.basicMap === true ? (
                                <BasicMap
                                  data={projectsByWard}
                                  municipality={this.municipality}
                                  onWardHover={(wardData) =>
                                    this.setState({
                                      hoveredWardStats: wardData,
                                    })
                                  }
                                  onWardLeave={() =>
                                    this.setState({ hoveredWardStats: null })
                                  }
                                />
                              ) : (
                                projectsByWard && (
                                  <Map
                                    class={"w-full"}
                                    data={projectsByWard}
                                    selectedDropDown={
                                      this.state.selectedDropDown
                                    }
                                    municipality={this.municipality}
                                    onWardHover={(wardData) =>
                                      this.setState({
                                        hoveredWardStats: wardData,
                                      })
                                    }
                                    onWardLeave={() =>
                                      this.setState({ hoveredWardStats: null })
                                    }
                                    projectType='local-project'
                                  />
                                )
                              )}
                              {mapInfo.basicMap === true ? (
                                ""
                              ) : (
                                <Legend legendData={legendData} />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='dashboard-layout inner-layout'>
                          <div className='project-section'>
                            <div className='flex flex-col gap-2 w-full'>
                              <span className={textSizeClass}>
                                {selectedLanguage === "en" ? (
                                  <Fragment>
                                    <span className='opacity-70'>
                                      {statsFor}
                                    </span>{" "}
                                    <strong>
                                      {this.state.hoveredWardStats
                                        ? `${ward} ${number(
                                            this.state.hoveredWardStats.ward
                                          )}`
                                        : `${allWards}`}
                                    </strong>
                                  </Fragment>
                                ) : (
                                  <Fragment>
                                    <span>
                                      {this.state.hoveredWardStats ? (
                                        <Fragment>
                                          <strong>{allWards}</strong>{" "}
                                          <span className='opacity-70'>
                                            {statsFor}
                                          </span>{" "}
                                          <strong>
                                            {ward}{" "}
                                            {number(
                                              this.state.hoveredWardStats.ward
                                            )}
                                          </strong>{" "}
                                          <span className='opacity-70'>
                                            का लागि {stats}
                                          </span>
                                        </Fragment>
                                      ) : (
                                        <Fragment>
                                          <strong>{allWards}</strong>{" "}
                                          <span className='opacity-70'>
                                            {statsFor}
                                          </span>
                                        </Fragment>
                                      )}
                                    </span>
                                  </Fragment>
                                )}
                              </span>
                              <div className='project-type-section flex justify-between items-center gap-10 card--chart py-3 px-4'>
                                <div className='flex flex-col gap-1'>
                                  <span className='text-3xl font-bold'>
                                    {this.state.hoveredWardStats
                                      ? number(
                                          this.state.hoveredWardStats
                                            .status_counts.submitted +
                                            this.state.hoveredWardStats
                                              .status_counts.evaluated
                                        )
                                      : projectStats
                                      ? number(
                                          projectStats.submitted_projects +
                                            projectStats.evaluated_projects
                                        )
                                      : number(0)}
                                  </span>
                                  <span className={textSizeClass}>
                                    {total_projects}
                                  </span>
                                </div>
                                <div className='flex flex-col justify-between card-stats'>
                                  <div className='flex flex-col gap-1'>
                                    <span className='text-base font-bold'>
                                      {this.state.hoveredWardStats
                                        ? number(
                                            this.state.hoveredWardStats
                                              .status_counts.submitted
                                          )
                                        : number(
                                            projectStats.submitted_projects
                                          )}
                                    </span>
                                    <span className={textSizeClass}>
                                      {submitted}
                                    </span>
                                  </div>
                                  <div className='flex flex-col gap-1'>
                                    <span className='text-base font-bold'>
                                      {this.state.hoveredWardStats
                                        ? number(
                                            this.state.hoveredWardStats
                                              .status_counts.evaluated
                                          )
                                        : number(
                                            projectStats.evaluated_projects
                                          )}
                                    </span>
                                    <span className={textSizeClass}>
                                      {evaluated}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='flex flex-col w-full'>
                              <Heading.h2
                                uppercase
                                className='chart-label flex items-center'
                              >
                                <Text.span className='help-text'>
                                  <Text.span className='help-text__icon'>
                                    <img
                                      className='help-icon'
                                      height={18}
                                      width={18}
                                      src={images.icons.help}
                                      alt='help'
                                    />
                                  </Text.span>
                                  <Text.span className='help-text__content tooltip'>
                                    <Text.span className='tooltip-arrow'>
                                      arrow
                                    </Text.span>
                                    {budget}
                                  </Text.span>
                                </Text.span>
                                <Text.span className={textSizeClass}>
                                  {this.state.hoveredWardStats ? (
                                    selectedLanguage === "en" ? (
                                      <span className='inline-flex gap-1'>
                                        <span className='opacity-70'>
                                          {budgetFor}
                                        </span>
                                        <strong>
                                          {ward}{" "}
                                          {number(
                                            this.state.hoveredWardStats.ward
                                          )}
                                        </strong>
                                      </span>
                                    ) : (
                                      <span className='inline-flex gap-1'>
                                        <strong>
                                          {ward}{" "}
                                          {number(
                                            this.state.hoveredWardStats.ward
                                          )}
                                        </strong>{" "}
                                        <span className='opacity-70'>
                                          {budgetFor}
                                        </span>
                                      </span>
                                    )
                                  ) : (
                                    <span className='opacity-70'>{budget}</span>
                                  )}
                                </Text.span>
                              </Heading.h2>
                              <div className='project-type-section flex justify-center items-center gap-10 card--chart h-full'>
                                <div className='flex flex-col items-center gap-1'>
                                  <span className='text-3xl font-bold'>
                                    {this.state.hoveredWardStats
                                      ? currency(
                                          this.state.hoveredWardStats
                                            .estimated_cost
                                        )
                                      : currency(projectStats.budget_sum)}
                                  </span>
                                  <span className={textSizeClass}>
                                    {expectedBudget}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <EvaluationScoreChart
                            evaluatedScore={evaluatedTotalScore}
                            wardWiseEvaluatedScore={wardWiseEvaluatedScore}
                            hoveredWardStats={this.state.hoveredWardStats}
                            chartTitle={
                              selectedLanguage === "np"
                                ? "मूल्यांकन स्कोर"
                                : "Evaluation Score"
                            }
                            chartHelpText={
                              selectedLanguage === "np"
                                ? "परियोजनाहरूको मूल्यांकन स्कोरको विवरण"
                                : "Breakdown of projects by evaluation score"
                            }
                          />
                        </div>
                      </div>
                      <div className='dashboard-layout'>
                        <WardChart
                          chartTitle={
                            selectedLanguage === "np"
                              ? "वडागतरुपमा परियोजनाको वितरण"
                              : "Ward wise bar view"
                          }
                          chartHelpText={
                            selectedLanguage === "np"
                              ? " यस bar chart ले विभिन्‍न वडा मार्फत वितरण परियोजनाहरुको कुल संख्या देखाउँछ।"
                              : "This bar chart shows the distribution of total number of local projects across the different wards."
                          }
                          projectType='local-project'
                          data={this.props}
                          selectedWard={this.props.selectedWard}
                          selectedDropDown={this.state.selectedDropDown}
                          localProjectData={this.selectedYearData || {}}
                        />
                      </div>
                    </div>
                  </LeftSection>
                ))}
            </HomePage>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

const LeftSection = styled.div`
                                            .project-distribution {
                                            color: rgba(255, 255, 255, 0.7);
                                            // font-size: ${(props) =>
                                              props.lang === "en"
                                                ? "12px"
                                                : "14px"};
                                            line-height: 24px;
                                            margin: 0 0 36px;
                                        }

                                            .selection-wrap {
                                            margin - left: ${(props) =>
                                              props.lang === "en"
                                                ? "5px"
                                                : "0"};
                                            margin-right: ${(props) =>
                                              props.lang === "en"
                                                ? "0"
                                                : "5px"};
                                        }

                                            .title {
                                            font - size: ${(props) =>
                                              props.lang === "en"
                                                ? "12px"
                                                : "14px"};
                                        }

                                            h3 {
                                            margin - bottom: 20px;
                                            > span:last-child {
                                            font-size: ${(props) =>
                                              props.lang === "en"
                                                ? "12px"
                                                : "14px"};
                                            opacity: 0.5;
                                        }
                                        }

                                            .stats-label {
                                            display: block;
                                            /* ${media.tabletWide`margin-left:10px`}; */
                                        }

                                            .map-section {
                                            position: relative;
                                        }

                                            @media all and (max-width: 768px) {
                                            > div {
                                            margin-bottom: 20px;
                                        }
                                        }
                                        }

                                            .upper-chart-section {
                                        @media all and (min-width: 600px) and (max-width: 991px), (min-width: 1200px) {
                                            display: flex;
                                        }
                                        }

                                            .project-type-section ul {
                                            display: flex;
                                            margin-right: -4px;
                                            margin-bottom: 20px;
                                            flex-wrap: wrap;

                                            li {
                                            margin-bottom: 8px;
                                            margin-right: 4px;

                                            &.active {
                                            span {
                                            background: #ecc417;
                                            color: #252E3B;
                                        }
                                        }

                                            &:hover, &:focus {
                                            cursor: pointer;
                                        }

                                            span {
                                            display: inline-block;
                                            background: #252E3B;
                                            padding: 4px 14px;
                                            border-radius: 30px;
                                            transition: 0.23s ease-in-out;

                                            &:active, &:hover, &.active {
                                            background: #ecc417;
                                            color: #252E3B;
                                            transition: 0.23s ease-in-out;
                                        }

                                        }
                                        }
                                        }

                                            .bar-chart-label {
                                            /* width: ${(props) =>
                                              `${props.width - 20}px`}; */
                                            margin - top: 10px;
                                            margin-left: 42px;
                                            text-align: center;
                                            fill: #fff;
                                            span {
                                            font-size: ${(props) =>
                                              props.lang === "en"
                                                ? "12px"
                                                : "14px"};
                                        }
                                            > span {
                                            display: block;
                                            position: relative;
                                            &:before {
                                            background-color: ${(props) =>
                                              props.theme.dark.slateGrey};
                                            content: '';
                                            height: 1px;
                                            position: absolute;
                                            bottom: 7px;
                                            left: 0;
                                            width: 45%;
                                        }
                                            &:after {
                                            background-color: ${(props) =>
                                              props.theme.dark.slateGrey};
                                            content: '';
                                            height: 1px;
                                            position: absolute;
                                            bottom: 7px;
                                            right: 0;
                                            width: 45%;
                                        }
                                        }
                                            &.vertical {
                                            transform: rotate(-90deg);
                                            position: absolute;
                                            left: -68px;
                                            top: 110px;
                                            width: 150px;
                                            margin: 0;
                                            /* width: initial; */
                                            > span {
                                            &:before {
                                            width: 30%;
                                        }
                                            &:after {
                                            width: 30%;
                                        }
                                            > span {
                                            background: #0e1724;
                                            position: relative;
                                            z-index: 1;
                                            padding-left: 4px;
                                            padding-right: 4px;
                                        }
                                        }
                                        }
                                        }
                                            .help-text__content {
                                            font - size: ${(props) =>
                                              props.lang === "en"
                                                ? "11px"
                                                : "13px"};
                                        }
                                            `;

const Dropdown = styled.div`
  cursor: pointer;
  position: relative;
  .filter-label {
    color: ${(props) => props.theme.primary.white};
    cursor: pointer;
    display: block;
    font-size: ${(props) => props.theme.fontSize.sm}px;
    margin: 11px 0;
    padding: 0 11px 0 21px;
    position: relative;
    text-transform: uppercase;
    &:before {
      background: url(${images.icons.sprite}) no-repeat -55px -38px;
      content: "";
      height: 14px;
      left: 0;
      position: absolute;
      top: 13px;
      width: 16px;
    }
    &:after {
      border-top: 4px solid ${(props) => props.theme.dark.slateGrey};
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      content: "";
      right: -1px;
      position: absolute;
      top: 18px;
    }
  }
  .dropdown-list {
    background: ${(props) => props.theme.primary.darkGrey};
    padding: 10px;
    border-radius: 4px;
    li {
      cursor: pointer;
      & + li {
        border-top: 1px solid ${(props) => props.theme.dark.slateGrey};
        margin-top: 5px;
        padding-top: 5px;
      }
    }
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(25px);
  transition: all 0.2s ease-in-out;
`;

const DropdownButton = styled.div`
  align-items: center;
  display: flex;
`;

const transitionStyles = {
  entered: {
    opacity: 1,
    visibility: "visible",
    transform: "translateY(25px)",
  },
};

const Title = styled.span`
  background: transparent;
  border: 0;
  color: var(--color-theme-1);
  display: block;
  font: ${(props) => props.theme.fontWeight.bold}
    ${(props) => props.theme.fontSize.sm}px
    ${(props) => props.theme.fontFamily.sansSerif};
  padding: ${(props) =>
    props.lang === "en" ? "7px 8px 7px 10px" : "4px 8px 4px 10px"};
  text-transform: uppercase;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const DropdownIcon = styled.span`
  border-color: ${(props) =>
    props.isOpen
      ? "transparent transparent #5D636D"
      : "#5D636D transparent transparent;"};
  border-width: ${(props) => (props.isOpen ? "0 4px 4px" : "4px 4px 0")};
  border-style: solid;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
`;

const mapStateToProps = (state) => ({
  projectsStats: state.projectsStatsReducers,
  selectedWard: state.projectsStatsReducers.selectedWard,
  selectedLanguage: state.localizationReducers.selectedLanguage,
  fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
  filters: state.infraMonitor.filters,
  municipalities: state.staticData.municipalities,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchProjectsStats: (filters, municipality) => {
    dispatch(getProjectsStats());
    dispatch(setFilters(filters));
    infraMonitorService
      .getProjectsStatsFiltered({ ...filters }, municipality.title_en)
      .then((response) => {
        dispatch(getProjectsStatsSuccess(response));
      });
  },
  dispatchSelectedWard: (selectedWard) =>
    dispatch(setSelectedWard(selectedWard)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/pages/home/home.js